import React from 'react';

import { Container } from './styles';

const DropdownCard: React.FC = ({ children }) => (
  <Container className="dropdown-card">{children}</Container>
);

export default DropdownCard;
